export const fmt = (n) => new Intl.NumberFormat("uk-UA").format(Math.round(n || 0));
export const fmtUAH = (n) => `${fmt(n)} \u20B4`;

export const toLocalDate = (d) => {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
};

export const getRozetkaUrl = (productId) =>
  productId ? `https://rozetka.com.ua/${productId}/p${productId}/` : "#";

export const exportXlsx = (sheets, filename) => {
  import("xlsx").then(XLSX => {
    const wb = XLSX.utils.book_new();
    sheets.forEach(({ name, rows }) => {
      const ws = XLSX.utils.aoa_to_sheet(rows);
      // Auto column widths
      const colWidths = rows[0]?.map((_, ci) =>
        Math.min(50, Math.max(10, ...rows.map(r => String(r[ci] ?? "").length)))
      ) || [];
      ws["!cols"] = colWidths.map(w => ({ wch: w }));
      XLSX.utils.book_append_sheet(wb, ws, name.slice(0, 31));
    });
    XLSX.writeFile(wb, filename);
  });
};
